import { Form, Select } from "antd"

interface CalendarAddExternalParticipantsFormItemProps {
  name?: string
}

export function CalendarAddExternalParticipantsFormItem({
  name = "external_participants"
}: CalendarAddExternalParticipantsFormItemProps) {
  return (
    <Form.Item
      label="Additional invitations"
      name={name}
      extra="Team members selected above are already invited by email. A teammate's address added here receives the full internal details; any other address receives the appointment only."
      rules={[
        {
          validator: (_, value) => {
            if (!value || value.length === 0) return Promise.resolve()

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            const invalid = value.filter(
              (email: string) => email && !emailRegex.test(email)
            )

            if (invalid.length > 0) {
              return Promise.reject(`Invalid email: ${invalid.join(", ")}`)
            }
            return Promise.resolve()
          }
        }
      ]}
    >
      <Select
        mode="tags"
        size="large"
        // The list only ever echoed back what was being typed, and in tags
        // mode a chosen address stays in it as a selected option — so
        // pressing that echo again, which is all a double click is, silently
        // took the address back off. There is nothing to choose from here, so
        // the addresses are committed by Enter or a separator instead.
        open={false}
        placeholder="Enter email recipients"
        tokenSeparators={[",", " "]}
      />
    </Form.Item>
  )
}
